import { render, staticRenderFns } from "./QuizTemplate1.vue?vue&type=template&id=21f46c8b"
import script from "./QuizTemplate1.vue?vue&type=script&lang=js"
export * from "./QuizTemplate1.vue?vue&type=script&lang=js"
import style0 from "./QuizTemplate1.vue?vue&type=style&index=0&id=21f46c8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports